import { useDevicesStore } from "../../store/devicesStore";
import { ChannelNode } from "../DeviceTree/ChannelNode";
import type { Device } from "../../types";

interface Props {
  device: Device | null;
}

// Lista de canales del dispositivo elegido, arrastrables a la grilla de playback.
// Reusa ChannelNode (drag source tipo "CHANNEL"). La grilla es siempre de un solo
// equipo, asi que mostramos solo los canales de ese device.
export function PlaybackChannelList({ device }: Props) {
  const channelsByDevice = useDevicesStore((s) => s.channelsByDevice);
  const channels = device ? channelsByDevice[device.id] || [] : [];

  return (
    <div className="flex flex-col h-full bg-panel border-r border-line">
      <div className="px-2 py-1.5 border-b border-line text-xs font-semibold uppercase text-muted truncate">
        {device ? device.name : "Canales"}
      </div>
      <div className="flex-1 overflow-auto py-1">
        {!device && (
          <p className="text-muted text-xs text-center mt-4 px-2">
            Elegi un dispositivo arriba para ver sus canales.
          </p>
        )}
        {device && channels.length === 0 && (
          <p className="text-muted text-xs text-center mt-4 px-2">
            Sin canales. Sincronizalos en la pagina "Dispositivos".
          </p>
        )}
        {device && channels.map((ch) => (
          <ChannelNode key={ch.channel_number} device={device} channel={ch} />
        ))}
      </div>
      {device && channels.length > 0 && (
        <div className="px-2 py-1 border-t border-line text-[10px] text-muted">
          Arrastra canales a la grilla →
        </div>
      )}
    </div>
  );
}
